module.exports = require("./az-Arab.js");